import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Contact2, UserX, UserCheck, PhoneOutgoing, Hourglass, ClipboardCheck,
  TrendingUp, Building2,
} from "lucide-react";
import { StatCard, BarRow } from "./DashBits";
import WidgetExport from "./WidgetExport";
export default function OverviewTab({ data, drill }) {
  const p = data.progress;
  const dc = data.data_capture;
  const kpis = [
    { label: "Total Uploaded", value: p.total, icon: Contact2, accent: "text-indigo-600", onClick: () => drill({}) },
    { label: "Unassigned", value: p.unassigned, icon: UserX, accent: "text-rose-600", onClick: () => drill({ assignee: "__unassigned__" }) },
    { label: "Assigned", value: p.assigned, icon: UserCheck, accent: "text-sky-600" },
    { label: "Worked", value: p.worked, icon: PhoneOutgoing, accent: "text-purple-600" },
    { label: "Pending", value: p.pending, icon: Hourglass, accent: "text-amber-600" },
    { label: "Completed (DC)", value: p.completed, icon: ClipboardCheck, accent: "text-emerald-600", onClick: () => drill({ disposition: "DC" }) },
    { label: "Completion %", value: `${p.completion_pct}%`, icon: TrendingUp, accent: "text-emerald-600" },
  ];
  const captureRows = [
    ["Employee Count", dc.employee_count], ["Sector", dc.sector], ["POC details", dc.poc],
    ["Head Office", dc.hq], ["Email", dc.email],
  ];
  return (
    <div className="space-y-4" data-testid="dash-tab-overview">
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3">
        {kpis.map((k) => (
          <StatCard key={k.label} {...k}
                    testid={`kpi-${k.label.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase()}`} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm flex items-center gap-2">
            <Building2 className="w-4 h-4 text-sky-600" /> Head Office
          </CardTitle></CardHeader>
          <CardContent className="space-y-1.5" data-testid="hq-card">
            <BarRow label="HQ available" count={data.hq.available} total={p.total} color="#0284C7"
                    onClick={() => drill({ hq: "yes" })} testid="hq-available-row" />
            <BarRow label="HQ missing" count={data.hq.missing} total={p.total} color="#CBD5E1"
                    onClick={() => drill({ hq: "no" })} testid="hq-missing-row" />
            <div className="text-[11px] text-slate-500 pt-1">
              Completion: <span className="font-semibold text-slate-800">{data.hq.pct}%</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm">Data Capture</CardTitle></CardHeader>
          <CardContent className="space-y-1.5" data-testid="capture-card">
            {captureRows.map(([label, count]) => (
              <BarRow key={label} label={label} count={count} total={p.total} color="#059669" />
            ))}
            <div className="flex items-center justify-between text-[11px] pt-1">
              <span className="text-emerald-700">Complete profiles: <b>{dc.complete_profiles}</b></span>
              <span className="text-amber-700">Incomplete: <b>{dc.incomplete_profiles}</b></span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2 flex flex-row items-center justify-between">
            <CardTitle className="text-sm">Classification (0–8)</CardTitle>
            <WidgetExport title="Classification" headers={["Class", "Total", "Completed", "Pending", "Completion %"]}
                          getRows={() => data.classification.map((r) => [r.cls, r.total, r.completed, r.pending, r.pct])} />
          </CardHeader>
          <CardContent className="p-2" data-testid="classification-card">
            <table className="w-full text-xs">
              <thead className="text-[10px] uppercase text-slate-400">
                <tr><th className="text-left px-2 py-1">Class</th><th className="text-right px-2">Total</th>
                    <th className="text-right px-2">Done</th><th className="text-right px-2">Pending</th>
                    <th className="text-right px-2">%</th></tr>
              </thead>
              <tbody>
                {data.classification.map((r) => (
                  <tr key={r.cls} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer"
                      onClick={() => r.cls !== "—" && drill({ classification: String(r.cls) })}
                      data-testid={`class-row-${r.cls}`}>
                    <td className="px-2 py-1"><Badge variant="outline" className="text-[10px] font-mono">{r.cls}</Badge></td>
                    <td className="text-right px-2 font-mono">{r.total}</td>
                    <td className="text-right px-2 font-mono text-emerald-700">{r.completed}</td>
                    <td className="text-right px-2 font-mono text-amber-700">{r.pending}</td>
                    <td className="text-right px-2 font-mono">{r.pct}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
